<template>
  <div>
    <CRow class="no-gutters px-3 px-sm-0">
      <b-col xl="12" class="text-center text-sm-left mb-3 mb-sm-0">
        <div class="d-flex justify-content-between">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการขนส่ง ({{rows}})</h1>
          <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
            <font-awesome-icon
              icon="filter"
              title="filter-btn"
              class="main-color mr-0 mr-sm-1"
            />
            <span class="d-none d-sm-inline">ตัวกรอง </span>
          </b-button>
        </div>
      </b-col>
    </CRow>
    <b-sidebar
      v-model="isModal"
      id="sidebar-filter"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
      aria-labelledby="sidebar-filter-title"
      no-header
    >
      <template #default="{ hide }">
        <div class="p-3 sidebar-filter-header d-flex justify-content-between">
          <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
          <font-awesome-icon
            class="my-auto"
            icon="times-circle"
            color="#FFFFFF"
            @click="hide"
          />
        </div>
        <div class="px-3 py-2">
          <div class="mt-3">
            <div class="font-weight-bold mb-2">วันที่ทำรายการ (เริ่มต้น)</div>
            <div :class="['input-container']">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.StartDate"
                placeholder="วว / ดด / ปป"
                ref="startDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.startDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">วันที่ทำรายการ (สิ้นสุด)</div>
            <div :class="['input-container']">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.EndDate"
                placeholder="วว / ดด / ปป"
                ref="endDate"
                :min-datetime="minBirthdate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.endDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
            <p class="text-red mt-2" v-if="error.errorDate">
              กรุณาเลือกวันที่เริ่ม
            </p>
          </div>

          <!-- <div class="mt-3">
            <div class="font-weight-bold mb-2">ช่องทางการซื้อ</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(channel, index) in saleChannelConfigList"
                :key="index"
                :value="channel.id"
                class="mb-2"
                v-model="filter.SellerShopId"
                >{{ channel.name }}</b-form-checkbox
              >
            </b-form-group>
          </div> -->

          <div class="mt-3">
            <div class="font-weight-bold mb-2">แบรนด์</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(channel, index) in brandIDList"
                :key="index"
                :value="channel.id"
                class="mb-2"
                v-model="filter.brandID"
                >{{ channel.name }}</b-form-checkbox
              >
            </b-form-group>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">ช่องทางการจัดส่ง</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(delivery, index) in deliveryChannalConfigList"
                :key="index"
                :value="delivery.id"
                class="mb-2"
                v-model="filter.ShippingTypeId"
                >{{ delivery.name }}</b-form-checkbox
              >
            </b-form-group>
          </div>
        </div>
      </template>

      <template #footer>
        <div
          class="d-flex justify-content-between shadow align-items-center border-top"
        >
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-dark w-100 border-radius-0 btn-clear-filter"
              @click="clearFilter"
            >
              ล้างตัวกรอง
            </b-button>
          </div>
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-body btn-main w-100 border-radius-0"
              @click="onSubmitFilter"
            >
              ยืนยัน
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
    <div class="bg-white py-3 py-sm-0 mt-4">
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col>
          <b-table
            responsive
            class="text-center table-list mb-0"
            striped
            :fields="fields"
            :items="items"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:cell(transportId)="data">
              <div>
                {{ data.item.transportId || "-" }}
              </div>
            </template>

            <template v-slot:cell(dateOrder)="data">
              <div>
                {{ new Date(data.item.dateOrder) | moment($formatDateTime) }}
              </div>
            </template>

            <template v-slot:cell(orderQuantity)="data">
              <div>
                {{ data.item.orderQuantity || "-" }}
              </div>
            </template>

            <template v-slot:cell(carRegistration)="data">
              <div>
                {{ data.item.carRegistration || "-" }}
              </div>
            </template>

            <template v-slot:cell(shippingType)="data">
              <div>
                {{ data.item.shippingType || "-" }}
              </div>
            </template>

            <template v-slot:cell(sellerShop)="data">
              <div>
                {{ data.item.sellerShop || "-" }}
              </div>
            </template>

            <template v-slot:cell(staff)="data">
              <div>
                {{ data.item.staff || "-" }}
              </div>
            </template>

            <template v-slot:cell(orderId)="data">
              <b-button variant="link" class="px-1 py-0">
                <router-link
                  :to="
                    '/transport/details/' +
                    data.item.transportId +
                    '?brandID=' +
                    $route.query.brandID
                  "
                  class="text-purple-1"
                >
                  <u>ดูรายละเอียด</u>
                </router-link>
              </b-button>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.Skip"
              :total-rows="rows"
              :per-page="filter.Take"
              class="m-md-0 page-item"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>

          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filter.Take"
            @change="hanndleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
    <!-- <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" /> -->
  </div>
</template>

<script>
// import ModalAlert from "@/components/modal/alert/ModalAlert";
// import ModalAlertError from "@/components/modal/alert/ModalAlertError";
// import ModalLoading from "@/components/modal/alert/ModalLoading";
import { mapGetters } from "vuex";

export default {
  // components: {
  //   ModalAlert,
  //   ModalAlertError,
  //   ModalLoading,
  // },
  data() {
    return {
      // modalMessage: "",
      isModal: false,
      fields: [
        // { key: "id", label: "" },
        {
          key: "transportId",
          label: `ลำดับการขนส่ง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "dateOrder",
          label: `วันที่ส่งมอบ`,
          class: "w-50px text-nowrap",
        },
        {
          key: "orderQuantity",
          label: `จำนวนรายการสั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "carRegistration",
          label: `ป้ายทะเบียนรถ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "shippingType",
          label: `ช่องทางการจัดส่ง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "sellerShop",
          label: `ช่องทาง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "staff",
          label: `โดย`,
          class: "w-100px text-nowrap",
        },
        { key: "orderId", label: "", class: "w-50px text-nowrap" },
      ],
      items: [],
      isBusy: false,
      filter: {
        ShippingTypeId: [],
        SellerShopId: [],
        brandID: [],
        StartDate: "",
        EndDate: "",
        Skip: 1,
        Take: 10,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      brandIDList: [],
      saleChannelConfigList: [],
      deliveryChannalConfigList: [],
      styleDatetime: {
        width: "100%",
        border: "none",
      },

      // state validate date
      maxBirthdate: null,
      minBirthdate: null,

      // state toggle
      error: {
        errorDate: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      GFilterTransport: "filter/getFilterTransport",
    }),
  },
  watch: {
    "filter.StartDate"(val) {
      if (val) {
        let date = new Date(val);
        this.minBirthdate = date.toISOString();

        this.error.errorDate = false;
      } else {
        this.minBirthdate = null;
      }
    },
    "filter.EndDate"() {
      if (!this.filter.StartDate) {
        this.error.errorDate = true;

        setTimeout(() => {
          this.filter.EndDate = "";
        }, 100);
      }
    },
  },
  created() {
    this.isFilter();
    this.getListFilter();
    this.getTransportList();

    // clear filter global
    this.$store.dispatch("filter/CHANGE_FILTERBATCH", null);
    this.$store.dispatch("filter/CHANGE_FILTERTRACKING", null);
    this.$store.dispatch("filter/CHANGE_FILTERSHIPPING", null);
    // this.$store.dispatch('filter/CHANGE_FILTERTRANSPORT',null)
  },
  methods: {
    isFilter() {
      if (this.GFilterTransport) {
        this.filter = this.GFilterTransport;
      }
    },
    getTransportList() {
      this.isBusy = true;

      this.axios
        .post(`${this.$baseUrl}/Batch/TransportList`, this.filter)
        .then((result) => {
          if (result.result == 1) {
            this.items = result.detail.transport;
            this.rows = result.detail.count;

            this.isBusy = false;

            this.$store.dispatch("filter/CHANGE_FILTERTRANSPORT", this.filter);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pagination(val) {
      this.filter.Skip = val;
      this.getTransportList();
    },
    hanndleChangePerpage() {
      this.getTransportList();
    },
    async getListFilter() {
      // let getSellerList = await this.axios.get(
      //   `${this.$baseUrl}/batch/seller/list`
      // );

      // if (getSellerList.result == 1) {
      //   this.saleChannelConfigList = getSellerList.detail;
      // }

      let getShippingList = await this.axios.get(
        `${this.$baseUrl}/batch/shipping/list`
      );

      if (getShippingList.result == 1) {
        this.deliveryChannalConfigList = getShippingList.detail;
      }

      let getBrandIDList = await this.axios.get(
        `${this.$baseUrl}/batch/brandList`
      );

      if (getBrandIDList.result == 1) {
        this.brandIDList = getBrandIDList.detail;
      }
    },
    onSubmitFilter() {
      this.isModal = false;

      this.getTransportList();
    },
    clearFilter() {
      setTimeout(() => {
        this.error.errorDate = false;
      }, 100);

      this.filter = {
        ShippingTypeId: [],
        SellerShopId: [],
        brandID: [],
        StartDate: "",
        EndDate: "",
        Skip: 1,
        Take: 10,
      };

      this.isModal = false;

      this.getTransportList();
    },
    colorDot(value) {
      let color = "none";

      if (value == 1) {
        color = "green";
      } else if (value == 2) {
        color = "orange";
      } else if (value == 3) {
        color = "red";
      }

      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.outofstock {
  background-color: #dc3545;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.date-cb {
  width: 120px;
}
.date-text {
  width: 120px;
}
.stock-text {
  min-width: 80px;
}
.price-text {
  white-space: nowrap;
}
.picture-text {
  min-width: 50px;
}
.checkbox-header {
  text-align: left;
}
.modal-link {
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}
.pictureUrl-square-box {
  margin: auto;
  width: 50%;
  padding-top: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.flag {
  font-size: 14px;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}

.text-red {
  color: red;
}

// new style
.dot {
  min-width: 15px;
  min-height: 15px;
  border-radius: 50%;

  &.none {
    background: transparent;
  }

  &.green {
    background: #27bda7;
  }

  &.orange {
    background: #faab32;
  }

  &.red {
    background: #ec6363;
  }
}
</style>
